import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';

const NavLinks = ({ isTransparent, isMobileMenuOpen, onLinkClick }) => {
    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: yCoordinate - 100, behavior: 'smooth' });
    };

    const handleClick = () => {
        if (onLinkClick) onLinkClick();
    };

    if (isMobileMenuOpen) {
        const mobileLinks = [
            { label: 'About', to: '/#about', type: 'hash' },
            { label: 'Our Partners', to: '/#partners', type: 'hash' },
            { label: 'Get Involved', to: '/#getinvolved', type: 'hash' },
            { label: 'Photos', to: '/photo-library', type: 'link' },
        ];

        return (
            <>
                {mobileLinks.map((item, index) => {
                    const className = "flex items-center w-full px-4 py-3.5 rounded-xl text-gray-700 hover:text-black hover:bg-gray-50 font-medium text-lg transition-all duration-150 mobile-nav-link";
                    const style = { animationDelay: `${index * 60}ms` };

                    return item.type === 'hash' ? (
                        <HashLink
                            key={item.label}
                            className={className}
                            style={style}
                            smooth
                            to={item.to}
                            scroll={scrollWithOffset}
                            onClick={handleClick}
                        >
                            {item.label}
                        </HashLink>
                    ) : (
                        <Link
                            key={item.label}
                            className={className}
                            style={style}
                            to={item.to}
                            onClick={handleClick}
                        >
                            {item.label}
                        </Link>
                    );
                })}

                {/* CTA button at bottom */}
                <div className="pt-4 mt-2 mobile-nav-link" style={{ animationDelay: '240ms' }}>
                    <Link
                        className="flex items-center justify-center w-full bg-black text-white px-6 py-3.5 rounded-xl font-semibold text-base hover:bg-gray-800 transition-colors duration-200"
                        to="/contact"
                        onClick={handleClick}
                    >
                        Contact Us
                        <svg className="w-4 h-4 ml-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                    </Link>
                </div>
            </>
        );
    }

    // Desktop links
    const desktopLinkClass = `px-4 font-bold transition-colors duration-150 ${
        isTransparent ? 'text-white hover:text-gray-300' : 'text-black hover:text-gray-500'
    }`;

    return (
        <>
            <HashLink className={desktopLinkClass} smooth to="/#about" scroll={scrollWithOffset}>
                About
            </HashLink>
            <HashLink className={desktopLinkClass} smooth to="/#partners" scroll={scrollWithOffset}>
                Our Partners
            </HashLink>
            <HashLink className={desktopLinkClass} smooth to="/#getinvolved" scroll={scrollWithOffset}>
                Get Involved
            </HashLink>
            <Link className={desktopLinkClass} to="/photo-library">
                Photos
            </Link>
            <Link
                className="text-white bg-black hover:bg-gray-800 inline-flex items-center justify-center px-6 py-3 shadow-xl rounded-xl transition-colors duration-150"
                to="/contact"
            >
                Contact Us
            </Link>
        </>
    );
};

export default NavLinks;
